import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { setupErrorLogging } from './Helpers/errorLogger';

setupErrorLogging();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <>
    <CssBaseline />
    <App />
  </>
);
